import { useQuery } from "@tanstack/react-query";
import {
  getDashboardStats,
  getTopClients,
  getRecentActivity,
  getExpiringSubscriptions,
} from "./dashboard.api";
import type {
  TopClientsParams,
  RecentActivityParams,
  ExpiringSubscriptionsParams,
} from "../types/dashboard.types";

export const useGetDashboardStats = () => {
  return useQuery({
    queryKey: ["dashboard-stats"],
    queryFn: getDashboardStats,
  });
};

export const useGetTopClients = (params: TopClientsParams = {}) => {
  return useQuery({
    queryKey: ["dashboard-top-clients", params.limit],
    queryFn: () => getTopClients(params),
  });
};

export const useGetRecentActivity = (params: RecentActivityParams = {}) => {
  return useQuery({
    queryKey: ["dashboard-recent-activity", params.limit],
    queryFn: () => getRecentActivity(params),
  });
};

export const useGetExpiringSubscriptions = (
  params: ExpiringSubscriptionsParams = {},
) => {
  return useQuery({
    queryKey: ["dashboard-expiring-subscriptions", params.days_ahead],
    queryFn: () => getExpiringSubscriptions(params),
  });
};
